(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["credits"] && !Shopify.designMode) return;
  try {
    const body = document.querySelector('body');
  const scrollObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.scrollWatcher) {
          case 'footer':
            body.classList.toggle('credits-active', entry.isIntersecting);
            break;
        } // endswitch
      });
    },
    { rootMargin: '150px 0px -45px 0px' },
  );

  const watcherFooter = document.querySelector('[data-scroll-watcher="footer"]');

  if (watcherFooter) {
    scrollObserver.observe(watcherFooter);
  } // endif
  } catch(e) { console.error(e); }
})();

})();
